import { render } from "./VideoFeed.vue?vue&type=template&id=2ea795a1"
import script from "./VideoFeed.vue?vue&type=script&lang=js"
export * from "./VideoFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__